import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single, _SystemPropertyOB } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { CDPsEditor } from "../../../../../../contabilidad/budgetRPFactory/CDPsEditor";
import { ObjectDinamicViewer } from "../../../../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import useModal, { MODAL_md } from "../../../../../../theme/Component/hooks/useModal";
import { SelectBudgetID } from "../../../../../../admin/configuracion/BudgetID/SelectBudgetID";

interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const RPAdjustmentAction = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {

    const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const _budgetRDFactory = useDataBean(_BudgetRPFactory);
    const [modalAssingCDP, setModalAssingCDP] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalBudget, setModalBudget] = useState<any>({ name: 'Seleccione el Rubro Presupuestal a Afectar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalEdit, setModalEdit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);
    const modalRubro = useModal("Cambiar Rubro", MODAL_md);


    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Apropiación', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const _systemProperties = useDataBean(_SystemPropertyOB);
    const [changeBudget, setChangeBudget] = useState(false);

    useEffect(() => {
        _systemProperties.instance.getSystemProperty("ChangeBudget").then(resp => {
            if (resp)
                setChangeBudget(resp.SystemValue == 'true');

        });
        if (data.BudgetList.DefaultValue) {
            setLista(data.BudgetList.DefaultValue)
        }
    }, [data.BudgetList])

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: () => { createBudget() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: data.BudgetList.Editable, evento: () => { setModalEdit({ ...modalEdit, "view": true, "name": `Editar Rubro ${bean.BudgetIDName ?? ""}` }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: false, evento: () => { eliminarItem() } },
            { titulo: 'Cambiar rubro', icono: 'ri-arrow-up-down-line', visible: changeBudget, evento: () => { modalRubro.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createBudget = () => {
        setBean({});
        _budgetRDFactory.setBean({});
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }


    const eliminarItem = () => {
        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const createItems = () => {
        const updatedLista = lista;

        _budgetRDFactory.instance.createBudgetRowForRP(
            bean.BudgetIDStr,
            bean.IDDocument,
            bean.DocumentDate,
            bean.IDBudgetResource,
            bean.IDBudgetSource,
            bean.Description,
            bean.Value
        ).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false })
                setModalAssingCDP({ ...modalAssingCDP, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const editItems = () => {
        const updatedLista = lista.map((bRow: any) =>
            // console.log(JSON.stringify(bRow.DataBeanProperties) === JSON.stringify(prevBean))
            JSON.stringify(bRow.DataBeanProperties) === JSON.stringify(prevBean)
                ? { ...bRow, DataBeanProperties: bean }
                : bRow
        );
        updatedLista.forEach(element => {
            element.DataBeanProperties.IndexID = _single.getRandomInt();
        });

        setLista(updatedLista);
        setModalEdit({ ...modalEdit, view: false });
    }

    const setRowBean = (e) => {
        console.log(e)
        setBean(e);
        setPrevBean(e);
    };

    const submitForm = () => {

        let key = Object.keys(data);
        console.log({ [key[0]]: lista });

        if (setData) {
            setData({ [key[0]]: lista });
        }
    }

    const headBudget = [
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Valor CDP', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor RCDP/RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
    ]

    const selectBudget = () => {
        setBean({
            ...bean,
            IDBudgetResource: _budgetRDFactory.bean.IDBudgetResource,
            BudgetIDStr: _budgetRDFactory.bean.BudgetIDStr,
            IDBudgetSource: _budgetRDFactory.bean.IDBudgetSource,
        });
        setModalBudget({ ...modalBudget, "view": false });
    }

    useEffect(() => {
        if (bean.IDDocument) {
            getBudgetByDoc();
        }
    }, [bean.IDDocument])

    const getBudgetByDoc = () => {
        _budgetRDFactory.instance.getCDPBudgetByDocument(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                setModalBudget({ ...modalBudget, "view": true })
                _budgetRDFactory.setLista(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }
    const updateBudgetCause = (index: number, budget: any) => {

        console.log(index, budget);


        lista.forEach(element => {
            if (element.DataBeanProperties.IndexID == index) {
                element.DataBeanProperties.BudgetIDStr = budget.JsonCode;
                element.DataBeanProperties.BudgetName = budget.JsonCode + " - " + budget.Name;
            }
        });
        setLista([...lista]);

    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>{data.BudgetList.Name}</label>
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Guardar</BasicButton>
            </div>
            <div className="col-md-12">
                <Modal modal={modalRubro.modal} updateModal={modalRubro.setModal} >
                    <div className="col-md-12">
                        <SelectBudgetID onChange={(e) => {
                            updateBudgetCause(bean.IndexID, e); console.log(e);
                        }} jsonCode={bean.BudgetIDStr} edit={false} />
                    </div>
                </Modal>
                <Modal modal={modal} updateModal={setModal} eventModal={createItems}>
                    <div className="row">
                        <div className="col-md-12">
                            <CDPsEditor onChange={(e) => { setBean({ ...bean, IDDocument: e.IDDocument, DocumentDate: e.Since }) }} value={bean.IDDocument} label="Selector de Certificado Disponibilidad Presupuestal" />
                        </div>
                        {bean.IDDocument &&
                            <div className="col-md-12">
                                <label >Rubro Seleccionado  <a className={`pointer ${_budgetRDFactory.bean.IDDocument ? "" : "d-none"}`} onClick={() => setModalBudget({ ...modalBudget, "view": true, "name": "Seleccione un rubro" })}>¿Cambiar?</a></label>
                                <ObjectDinamicViewer data={_budgetRDFactory.bean} head={headBudget} />
                            </div>
                        }
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, Value: e }) }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modalBudget} updateModal={setModalBudget} eventModal={() => {
                                if (_budgetRDFactory.bean.IDBudgetResource && _budgetRDFactory.bean.IDBudgetSource) {
                                    selectBudget()
                                } else {
                                    toast.error("Presupuesto no valido")
                                }
                            }} onSubmitLabel="Seleccionar" >
                                <BasicTable listButtons={listaBotones()} head={headBudget} body={_budgetRDFactory.lista} rowSet={_budgetRDFactory.setBean} />
                            </Modal>
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={editItems}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, Value: e }) }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}